module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-headset.36a72706.svg";